<template>
  <section class="page__heading bg-primary text-white text-center py-5 justify-content-center">
    <div class="content__column">
      <p class="text-small text-uppercase opacity-50">
        {{ question.category.partLabel }} &mdash;
        {{ __('qna.category.questionRange', [question.category.questionRange]) }}
      </p>

      <h1 class="font-weight-700 mb-5">{{ question.title }}</h1>

      <div v-show="showAnswer" class="anwser text-left mb-5">
        <span v-if="!isModeForChildren" v-html="question.answerAdults"/>
        <span v-else v-html="question.answerChildren"/>
      </div>

      <div class="toggle-answer">
        <div class="toggle-answer__handle" @click="showAnswer = !showAnswer">
          <i class="fa toggle-answer__icon" :class="{'fa-chevron-up': showAnswer, 'fa-chevron-down': !showAnswer}"
             aria-hidden="true"></i><br/>
          <span class="toggle-answer__label">
            <template v-if="!showAnswer">{{ __('qna.label.answer.show') }}</template>
            <template v-else>{{ __('qna.label.answer.hide') }}</template>
          </span>
        </div>
      </div>

      <div class="bible-vers">
        <span v-if="!isModeHSV" v-html="question.bibleVerseSv"/>
        <span v-else v-html="question.bibleVerseHsv"/>
        <br>
        <span class="vers" v-html="question.vers"></span>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "NccQuestionHeader",
    computed: {
      isModeForChildren() {
        return this.$store.getters['isModeForChildren'];
      },
      isModeHSV() {
        return this.$store.getters['isModeHSV'];
      },
      showAnswer: {
        get() {
          return this.$store.getters['showAnswer'];
        },
        set(show) {
          this.$store.commit('SET_SHOW_ANSWER', show)
        }
      },
      question() {
        return this.$store.getters['selectedQuestion'];
      }
    }
  }
</script>

<style lang="scss" scoped>
  .anwser {
    font-size: 1.5rem;
    line-height: 1.8;
    font-weight: 300;
    text-align: center;
    font-family: 'Merriweather', serif;
  }

  .toggle-answer__handle {
    display: inline-block;
    cursor: pointer;
    font-size: 1rem;

    .toggle-answer__label {
      margin-top: .25rem;
    }
  }

  .bible-vers {
    font-style: italic;
    margin-top: 2rem;
    line-height: 2;

    .vers {
      display: inline-block;
      margin-top: .5rem
    }

    .vers:before,
    .vers:after {
      display: inline-block;
      content: "—";
    }

    .vers:before {
      margin-right: .5rem
    }

    .vers:before {
      display: inline-block;
      content: "—";
      margin-left: .5rem
    }
  }

</style>
